/**
 * Маппинг Telegram-платформы (`tgWebAppPlatform` из launch params) в значение
 * пропа `platform` для `<AppRoot>` кита @telegram-apps/telegram-ui.
 *
 * Kit понимает только две формы (сверено по AppRootContext.d.ts, Веха 13.0):
 *   - `'ios'`  — iOS-стиль контролов (Apple HIG: формы, шрифты, отступы);
 *   - `'base'` — всё остальное (Android / Telegram Desktop / web / unknown).
 *
 * Apple-платформы Telegram — `'ios'` и `'macos'` (у macOS-клиента iOS-подобный UI).
 * Всё прочее (`'android'`, `'tdesktop'`, `'weba'`, `'webk'`, `'unigram'`, …) и
 * `undefined` → `'base'`. CANON G3: никогда не падает на неизвестном вводе.
 */
export function mapPlatform(tgWebAppPlatform: string | undefined): 'ios' | 'base' {
  return tgWebAppPlatform === 'ios' || tgWebAppPlatform === 'macos'
    ? 'ios'
    : 'base';
}
